import React from 'react'
import { motion } from 'framer-motion';
import { Grid, Col, PageTitle } from '../../styles/GlobalTheme/GlobalStyledComponents';
import { Items, Item, ItemIcon, ItemTitle, ItemText, Title, Text } from './StyledComponents';
import PageHeader from '../../components/PageHeader'
import { productsData } from '../../data/websiteData';
import Differentiator from '../../components/differentiator';

//Animation
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import LightSpeed from 'react-reveal/LightSpeed';

export const index = ({match}) => {
    let {id} = match.params
    return (
        <>
            <motion.div
                initial={{opacity: 0.5}}
                animate={{opacity: 1}}
                exit={{opacity: 0.5}}
            >
                <PageHeader title={productsData[id].title} image={productsData[id].headerImage}></PageHeader>
                <Grid>
                    <PageTitle mb="30">{productsData[id].pageTitle}</PageTitle>
                </Grid>
                <Grid mb="150">
                    <Items>
                        {productsData[id].features.map((item, index) => (
                        <Item>
                            <Flip left cascade duration={1500}>
                                <ItemIcon src={item.icon}></ItemIcon>
                            </Flip>
                            <Col>
                                {(item.title) && (
                                    <ItemTitle>
                                        <Fade bottom duration={1000}>{item.title}</Fade>
                                    </ItemTitle>
                                )}
                                <Fade bottom cascade duration={2000}>
                                    <ItemText>{item.text}</ItemText>
                                </Fade>
                            </Col>
                        </Item>
                        ))}
                    </Items>    
                </Grid>
                <Grid bgColor={productsData[id].differentiator.bgColor}>
                    <Differentiator data={productsData[id].differentiator}></Differentiator>
                </Grid>
                <Grid mb="105">
                    <Title>{productsData[id].content1.title}</Title>
                    {productsData[id].content1.list.map((item, index) => (
                        <Fade up cascade duration={1500}>
                            <Text>{item.text}</Text>
                        </Fade>
                    ))}
                </Grid>
            </motion.div>
        </>
    )
}

export default index